





















































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import Campaign from '@/store/entities/campaign';
import dayjs from "dayjs";
import Ajax from "@/lib/ajax";

@Component
export default class CreateCampaign extends AbpBase {
  @Prop({type: Boolean, default: false}) value: boolean;
  campaign: Campaign = new Campaign();
  organizations: any[] = new Array<any>();

  get loading() {
    return this.$store.state.campaign.loading;
  }

  get permissions() {
    return this.$store.state.campaign.permissions
  }

  async getAllOrganizations() {
    let response = await Ajax.get("/api/services/app/OrganizationUnitUsers/GetMyOrgList");

    let data = response.data.result;

    this.organizations = data;
    if (this.organizations.length > 0 && !this.campaign.organizationUnitId) {
      this.campaign.organizationUnitId = this.organizations[0].id;
    }

  }

  dateChange(date, t) {
    let time = !date ? null : dayjs(date).format('YYYY-MM-DD HH:mm:ss');
    if (t === 1) {
      this.campaign.startTime = time;
    } else if (t === 2) {
      this.campaign.endTime = time;
    }
  }

  save() {
    (this.$refs.campaignForm as any).validate(async (valid: boolean) => {
      if (valid) {

        if (!this.campaign.startTime || !this.campaign.endTime) {
          this.$Message.error('请选择活动时间');
          return;
        }
        if (!this.campaign.organizationUnitId||this.campaign.organizationUnitId==0) {
          this.$Message.error('请选择所属组织');
          return;
        }
 
        await this.$store.dispatch({
          type: 'campaign/create',
          data: this.campaign
        });
        (this.$refs.campaignForm as any).resetFields();
        this.$emit('save-success');
        this.$emit('input', false);
      }
    })
  }

  cancel() {
    (this.$refs.campaignForm as any).resetFields();
    this.$emit('input', false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value);
    } else {
 
    }
  }

  async created() {
    await this.getAllOrganizations();
  }

  campaignRule = {
    name: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('name')), trigger: 'blur'}],
    campaignCode: [{
      required: true,
      message: this.L('FieldIsRequired', undefined, this.L('campaignCode')),
      trigger: 'blur'
    }],
  }
}
